<!-- goBackWindow -->
<template>
  <van-dialog
    v-model="show"
    confirmButtonText="再看看其他课"
    confirmButtonColor="#787878"
    @confirm="dialogConfirm"
  >
    <p class="confirmText">这个课程很火爆哦，确定不想要？</p>
    <i class="closeButton" @click="dialogClose"></i>
    <button class="cancelButton" @click="dialogClose">继续购买</button>
  </van-dialog>
</template>

<script>
export default {
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  watch: {
    dialogShow(showStatus) {
      this.show = showStatus;
    },
  },

  components: {},

  mounted() {},

  methods: {
    dialogConfirm() {
      // 跳转到课程详情页
      // this.$router.replace('/');
      this.$emit('close');
      window.history.go(-1);
    },
    dialogClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
$remSize: 75;
$fontHeight: calc(29rem / 75);
@function remcalc($rem) {
  @return calc($rem / $remSize) * 1rem;
}

.van-overlay {
  background: rgba(0, 0, 0, 0.52);
}
.van-dialog {
  width: remcalc(634);
  border-radius: remcalc(7);

  .van-dialog__footer {
    height: remcalc(94);

    .van-button {
      height: 100%;
    }
  }

  .van-hairline--top::after {
    display: none;
  }

  .confirmText {
    padding-top: remcalc(98);
    padding-bottom: remcalc(100);
    color: #333;
    font-weight: bold;
    font-size: $fontHeight;
    text-align: center;
  }

  .closeButton {
    position: absolute;
    top: remcalc(34);
    right: remcalc(34);
    width: remcalc(29);
    height: remcalc(29);
    background: url('../../../assets/img/payment/dialog_close.png') no-repeat center;
    background-size: contain;
    cursor: pointer;
  }

  .cancelButton {
    display: block;
    height: remcalc(69);
    margin: 0 auto;
    padding: remcalc(14) remcalc(89);
    color: #fff;
    font-weight: bold;
    font-size: remcalc(29);
    background: #ff6c02;
    border-radius: remcalc(34.5);
  }

  .van-dialog__confirm {
    border: none;

    .van-button__content {
      .van-button__text {
        margin: $fontHeight;
        font-size: remcalc(25);
        line-height: remcalc(36);
      }
    }
  }
}
</style>
